import React from 'react';
import classnames from 'classnames';
import './index.scss';
import LogoText from '../LogoText';


export default function appointment({ open, onClose }) {
  return (
    <div className={classnames("appointment-root", { 'fade-in': open })}>
      <h2 className="title">预约试驾</h2>
      {renderSubTitile('意向车型')}
      <select className="select-box" name="" id="">
        <option>vv7</option>
      </select>
      <div className="mt10"></div>
      {renderSubTitile('个人信息')}
      <input className="input-box" type="text" placeholder="您的姓名"/> 
      <select className="select-box" name="" id="">
        <option>男</option>
        <option>女</option>
      </select>
      <input className="input-box" type="number" placeholder="您的手机号"/> 
      <div className="footer-box">
        <button className="button-box primary" onClick={onClose}>提交资料</button> 
        <button className="button-box" onClick={onClose}>返回看车</button> 
        <LogoText></LogoText>
      </div> 
    </div>
  )
}
function renderSubTitile(subTitle) {
  return (
    <div className="sub-title">
      <h3>{subTitle}</h3>
    </div>
  )
}